import { render } from "./BannerBottomComp.vue?vue&type=template&id=10efe1ef&scoped=true"
import script from "./BannerBottomComp.vue?vue&type=script&lang=js"
export * from "./BannerBottomComp.vue?vue&type=script&lang=js"

import "./BannerBottomComp.vue?vue&type=style&index=0&id=10efe1ef&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10efe1ef"]])

export default __exports__